import { defineMessages } from '../../i18n/define';
import { tr } from '../../i18n/runtime';

const m = defineMessages({
  notConnected: {
    id: 'data.refusal.notConnected',
    defaultMessage: 'база района этих данных пока не отдаёт — блок ещё не подключён к источнику',
    description: 'Причина пустого блока: сервер этих данных пока не отдаёт (строчная фраза после двоеточия: «Не загрузили …: …»)',
  },
});

/**
 * Отказ по набору, за который не взялся ни один адаптер: канон этих данных
 * экрану пока не отдаёт. Отдельная константа — оболочка узнаёт по ней отказ
 * источника и не называет его «данные ещё генерируются».
 */
export function notConnected(): string {
  return tr(m.notConnected);
}
